var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.49 12.55 3.856-4.03a.87.87 0 0 1 1.268 0c.35.366.35.96 0 1.325l-4.49 4.693a.87.87 0 0 1-1.268 0l-2.507-2.62a.968.968 0 0 1 0-1.326.87.87 0 0 1 1.268 0L9.49 12.55zm8.885-3.16c0 5.427-3.05 10.424-7.894 12.654-4.714-2.17-7.893-7.08-7.893-12.655V5.378l7.893-3.425 7.894 3.425v4.011zm1.241-5.504L10.826.072a.861.861 0 0 0-.688 0L1.347 3.886a.939.939 0 0 0-.553.866v4.637c0 6.385 3.692 12.129 9.349 14.541.217.093.46.093.677 0 5.656-2.412 9.349-8.156 9.349-14.54V4.751a.939.939 0 0 0-.553-.866z",
    fill: "#272726",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.fcc40468d49fdc16695805401ff235a4.svg";
export { ForwardRef as ReactComponent };